<template>
  <!--视频看房添加  -->
  <div class="topicAdd">
    <div class="add_box">
      <el-form
        :model="toAdDas"
        :rules="toAdRule"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%; margin: 20px auto"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="标题" prop="title">
              <el-input
                placeholder="请输入标题"
                v-model="toAdDas.title"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="置业经理" prop="salesmanId">
              <el-select
                clearable
                placeholder="请选择"
                v-model="toAdDas.salesmanId"
                style="width: 245px"
              >
                <el-option
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  v-for="item in salesmanList"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="楼盘名称" prop="floorId">
              <el-select
                clearable
                placeholder="请选择"
                v-model="toAdDas.floorId"
                style="width: 245px"
              >
                <el-option
                  :key="item.contentId"
                  :label="item.title"
                  :value="item.contentId"
                  v-for="item in listByLocation"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="视频" prop="videoUrl" ref="videoUrl">
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="upSuccess"
              >
                <video
                  v-if="toAdDas.videoUrl"
                  :src="toAdDas.videoUrl"
                  class="avatar"
                  style="width: 150px; height: auto"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin: 0 0 30px 145px">
          <el-col :span="10">
            <el-checkbox v-model="toAdDas.isJingjirenjianfang"
              >经纪人推荐</el-checkbox
            >
            <el-checkbox v-model="toAdDas.isKaipanshixian"
              >开盘视线</el-checkbox
            >
            <el-checkbox v-model="toAdDas.isZhuanyejianfang"
              >专业荐房</el-checkbox
            >
          </el-col>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitAdd('ruleForm')"
            v-if="menuPerm('special:add')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.coverUrl)
      if (this.toAdDas.videoUrl == "") {
        callback(new Error("视频不能为空"));
      } else {
        callback();
      }
    };

    return {
      loadUpt: false, //加载
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      //添加的参数：
      toAdDas: {
        salesmanId: "", // 置业经理 id
        videoUrl: "", //视频url
        title: "", //标题
        isZhuanyejianfang: "", //专业荐房
        isJingjirenjianfang: "", //经纪人推荐
        isKaipanshixian: "", //开盘视线
        floorId: "",
      },
      toAdRule: {
        salesmanId: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        title: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        floorId: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        isZhuanyejianfang: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        isJingjirenjianfang: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        isKaipanshixian: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        videoUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
      },
      type: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      salesmanList: [], //置业经理
      listByLocation: [],
    };
  },
  methods: {
    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      // time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    //新增专题：
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/floorVideo/insert", {
            videoUrl: this.toAdDas.videoUrl, //视频url
            title: this.toAdDas.title, //标题
            salesmanId: this.toAdDas.salesmanId, //置业经理id
            isZhuanyejianfang: Number(this.toAdDas.isZhuanyejianfang), //专业荐房
            isJingjirenjianfang: Number(this.toAdDas.isJingjirenjianfang), //经纪人推荐
            isKaipanshixian:Number(this.toAdDas.isKaipanshixian), //开盘视线
            floorId: this.toAdDas.floorId,
          }).then((res) => {
            if (res.success == true) {
              this.$router.push({ path: "/floorVideo" });
              this.$message.success("添加成功！");
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
    // 封面图上传成功
    upSuccess(file) {
      this.toAdDas.videoUrl = file.entity;
    },
    // 置业经理
    salesMan() {
      this.postAxios("/salesman/list", {
        pageNum: 0,
        pageSize: 0,
      }).then((res) => {
        this.salesmanList = res.content;
      });
    },
    listAllContent() {
      this.postAxios("/rotation/listAllContentByType", {
        page: {
          pageNum: 0,
          pageSize: 0,
        },
        q: {
          contentType: 12,
        },
      }).then((res) => {
        this.listByLocation = res.content;
      });
    },
  },
  mounted() {
    this.salesMan();
    this.listAllContent();
  },
};
</script>
<style scoped lang="less">
.topicAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    /deep/ .el-upload {
      width: 248px;
      height: auto;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      outline: 0;
      border: 2px dashed #eee;
      img {
        width: 100%;
        height: auto;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
</style>